import ACTIONS from '../actionTypes/release'

const initialState = {
  isCreatingRelease: false,
  createdRelease: null,
  errorCreatingRelease: false,
  reviewList: [],
  fetchingReviewList: false,
  errorFetchingReviewList: false,
  release: null,
  isFetchingCurrentRelease: false,
  isSubmittingReview: false,
  adminComments: [],
  fetchingAdminComments: false,
  errorFetchingAdminComment: false,
  releasesForApp: [],
  isFetchingReleasesForApp: false,
}

const ReleaseReducer = (state = initialState, action) => {
  switch (action.type) {

    // createRelease
    case ACTIONS.START_CREATE_RELEASE:
      return {
        ...state,
        isCreatingRelease: true
      }
    case ACTIONS.CREATE_RELEASE_SUCCESS:
      return {
        ...state,
        createdRelease: action.payload,
        isCreatingRelease: false,
        errorCreatingRelease: false
      }
    case ACTIONS.CREATE_RELEASE_FAILED:
      return {
        ...state,
        isCreatingRelease: false,
        errorCreatingRelease: true
      }

    // getPendingReviews
    case ACTIONS.START_GET_REVIEW_LIST:
      return {
        ...state,
        fetchingReviewList: true
      }
    case ACTIONS.GET_REVIEW_LIST_SUCCESS:
      return {
        ...state,
        reviewList: action.payload,
        fetchingReviewList: false,
        errorFetchingReviewList: false
      }
    case ACTIONS.GET_REVIEW_LIST_FAILED:
      return {
        ...state,
        fetchingReviewList: false,
        errorFetchingReviewList: true
      }

    // getReleaseById
    case ACTIONS.START_GET_RELEASE_BY_ID:
      return {
        ...state,
        release: null,
        isFetchingCurrentRelease: true
      }
    case ACTIONS.GET_RELEASE_BY_ID_SUCCESS:
      const release = action.payload
      return {
        ...state,
        isFetchingCurrentRelease: false,
        release
      }
    case ACTIONS.GET_RELEASE_BY_ID_FAILED:
      return {
        ...state,
        isFetchingCurrentRelease: false,
        release: null,
      }

    // submitReviewForRelease
    case ACTIONS.START_SUBMIT_REVIEW_FOR_RELEASE:
      return {
        ...state,
        isSubmittingReview: true
      }
    case ACTIONS.SUBMIT_REVIEW_FOR_RELEASE_SUCCESS:
      return {
        ...state,
        isSubmittingReview: false,
      }
    case ACTIONS.SUBMIT_REVIEW_FOR_RELEASE_FAILED:
      return {
        ...state,
        isSubmittingReview: false,
      }

    // getReleaseAdminCommentsForApplication
    case ACTIONS.START_ADMIN_COMMENTS_FOR_APPLICATION:
      return {
        ...state,
        fetchingAdminComments: true,
      }
    case ACTIONS.GET_ADMIN_COMMENTS_FOR_APPLICATION_SUCCESS:
      return {
        ...state,
        adminComments: action.payload,
        fetchingAdminComments: false,
      }
    case ACTIONS.GET_ADMIN_COMMENTS_FOR_APPLICATION_FAILED:
      return {
        ...state,
        errorFetchingAdminComment: true,
        fetchingAdminComments: false,
      }

    // getReleasesForApplication
    case ACTIONS.START_GET_RELEASES_FOR_APP:
      return {
        ...state,
        isFetchingReleasesForApp: true,
      }
    case ACTIONS.GET_RELEASES_FOR_APP_SUCCESS:
      return {
        ...state,
        releasesForApp: action.payload,
        isFetchingReleasesForApp: false,
      }
    case ACTIONS.GET_RELEASES_FOR_APP_FAILED:
      return {
        ...state,
        isFetchingReleasesForApp: false,
      }

    // Default
    default:
      return state
  }
}

export default ReleaseReducer